import { useCancellationPlan } from 'src/context/billing';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type Props = {
  refetch: () => void;
};

const CancellationSuccessDialog = ({ refetch }: Props) => {
  const {
    ui: { step, setInitialData },
  } = useCancellationPlan();

  const onOpenChange = (open: boolean) => {
    if (!open) {
      setInitialData();
      refetch();
    }
  };

  return (
    <Dialog open={step === 'cancellation-success'} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[512px] gap-6">
        <DialogHeader className="text-center gap-1.5">
          <DialogTitle>We&apos;re sorry to see you go</DialogTitle>
          <DialogDescription>
            Your cancellation request has been received and will be scheduled in line with our terms and conditions. We
            appreciate the time you&apos;ve spent with us and hope to see you again in the future.
            <br />
            <br />
            Please don’t hesitate to reach out if you change your mind!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex sm:justify-center">
          <DialogClose asChild>
            <Button>Back to dashboard</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CancellationSuccessDialog;
